import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import Paper from '@material-ui/core/Paper'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { withStyles } from '@material-ui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import Input from 'core/elements/input'

const escapeRegExp = (string) => {
  return string?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

@withStyles((theme) => ({
  dropdownButton: { cursor: 'pointer' },
  absolute: { position: 'absolute', zIndex: '9999' },
  relative: { position: 'relative' },
  dropdown: { maxHeight: 200, overflow: 'scroll' },
}))
class AutocompleteBase extends PureComponent {
  state = {
    value: this.props.initialValue || '',
    open: false,
  }

  matchedSuggestions = () => {
    const { suggestions } = this.props
    const { value } = this.state
    if (value.length === 0) {
      return suggestions
    }
    const escapedRegex = escapeRegExp(value)
    const r = new RegExp(escapedRegex)
    const matched = (suggestions || []).filter((x) => r.test(x))
    return matched
  }

  propogateChange = () => {
    if (this.props.onChange) {
      this.props.onChange(this.state.value)
    }
  }

  handleChange = (event) => {
    if (!event || !event.target) {
      return
    }
    const value = event.target.value
    // IDK why this callback is necessary, but I guess we will
    // find out if we ever use the key/value suggestions
    // this.setState({ value, open: true }, this.propogateChange)
    this.setState({ value, open: true })
    this.props.onChange(value)
  }

  // Note: that we are using `onMouseDown` instead of `onClick` to trigger this.
  // The reason is that the Textfield's `onBlur` is firing before the `onClick`
  // and deleting the suggestions when then makes it behave as if the suggestion
  // was never clicked.  `onBlur` does not happen until `onMouseUp` so this seems
  // to work.  Not sure about tap events.
  handleClick = (item) => () => {
    this.setState({ value: item, open: false }, this.propogateChange)
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  toggleOpen = () => {
    this.setState((state) => ({ open: !state.open }))
  }

  renderSuggestions = (suggestions) => {
    const { open } = this.state
    const { classes } = this.props
    if (!open || !suggestions || suggestions.length === 0) {
      return null
    }
    return (
      <Paper className={`${classes.container} ${classes.absolute}`}>
        <MenuList open className={clsx(classes.container, classes.dropdown)}>
          {suggestions.map((item) => (
            <MenuItem key={item} onMouseDown={this.handleClick(item)}>
              {item}
            </MenuItem>
          ))}
        </MenuList>
      </Paper>
    )
  }

  render() {
    const matched = this.matchedSuggestions()
    const { value } = this.state
    const { className, classes, suggestions, onChange, initialValue, label, id, onBlur, ...other } =
      this.props
    const DropdownIcon = <ArrowDropDownIcon className={classes.dropdownButton} />

    return (
      <div className={clsx(classes.relative, className)}>
        <FormControl className={classes.container} onMouseDown={this.toggleOpen}>
          <Input
            id={id}
            placeholder={label}
            value={value}
            onChange={this.handleChange}
            onBlur={(e) => {
              if (onBlur) {
                onBlur(e)
              }
              this.handleClose()
            }}
            endadornment={suggestions && DropdownIcon}
            {...other}
          ></Input>
        </FormControl>
        {this.renderSuggestions(matched)}
      </div>
    )
  }
}

// You can also pass any additional props and they will be added
// to the TextField.
AutocompleteBase.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  initialValue: PropTypes.string,
}

export default AutocompleteBase
